var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"20":1,"255":1,"310":1,"407":1,"427":1,"536":1,"629":1,"685":1,"803":1,"821":1,"864":1,"872":1,"901":1,"1030":1,"1071":1,"1164":1,"1396":1,"1422":1,"1465":1,"1834":1,"1887":1,"1926":1,"1991":1,"2003":1,"2033":1,"2051":1,"2291":1,"2335":1,"2515":1,"2557":1,"2648":1,"2654":1,"3180":1,"3191":1,"3271":1,"3649":1,"3671":1,"3672":1,"3722":1,"3734":1,"3759":1,"3767":1,"3791":1,"3820":1,"3903":1,"4265":1,"4353":1,"4407":1,"4424":1,"4432":1,"4442":1,"4475":1,"4501":1,"4656":1,"4972":1,"5066":1,"5151":1,"5188":1,"5262":1,"5346":1,"5380":1,"5418":1,"5526":1,"5609":1,"5619":1,"5795":1,"5877":1,"5902":1,"5940":1,"6006":1,"6040":1,"6129":1,"6396":1,"6508":1,"6552":1,"6589":1,"6672":1,"6890":1,"6998":1,"7053":1,"7163":1,"7228":1,"7239":1,"7242":1,"7257":1,"7386":1,"7456":1,"7466":1,"7489":1,"7628":1,"7648":1,"7709":1,"7790":1,"8005":1,"8035":1,"8159":1,"8230":1,"8244":1,"8271":1,"8335":1,"8644":1,"8671":1,"8702":1,"8772":1,"9050":1,"9126":1,"9209":1,"9220":1,"9239":1,"9251":1,"9383":1,"9674":1,"9909":1,"9979":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr